import Avatar from "react-avatar";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import styles from "./Header.module.scss";
function Header() {
  const location = useLocation();
  const user = useSelector((state) => state.authentication.user);
  const userProfile = useSelector((state) => state.authentication.userProfile);
  const jobTitle = location?.state?.jobTitle;
  const HeaderTitle = () => {
    const path = location.pathname.split("/")[1];
    if (path === "") {
      return "Dashboard";
    } else if (path === "openings") {
      return "Openings";
    } else if (path === "applicants") {
      if(jobTitle){
       return `Applicants for ${jobTitle}` 
      }
      else{
        return "Applicants"
      }
    } else if (path === "master-data") {
      return "Master Data";
    } else if (path === "referral-profile") {
      return "Referral Job Profiles";
    } else if (path === "alerts") {
      return "Alerts";
    } else if (path === "resources") {
      return "Resources"
    } else if (path === "settings") {
      return "Settings"
    }
  };
  return (
    <>
      <div className={styles.header}>
        <div className={styles.headerTitle}>{HeaderTitle()}</div>

        <div className={styles.profileBlock}>
          <div className={styles.loggerUser}>
          <span className={styles.userNamePart}>
            Welcome, <br/> {userProfile && userProfile?.resource && userProfile?.resource?.name}{" "}{userProfile && userProfile?.resource && userProfile?.resource?.lastName}
          </span>
          {/* <div className={`${styles.profileImage}`}>
            <span>{user && user?.name.charAt(0)}</span>
          </div> */}
          <div className={styles.avtarPart}>

            {userProfile && userProfile?.resource?.avtar?.url ?
              <Avatar
                className={styles.commentAvt}
                facebook-id="invalidfacebookusername"
                src={userProfile?.resource?.avtar?.url ? userProfile?.resource?.avtar?.url : user?.avtar?.url}
                size="37"
                round={true}
              />
              : <Avatar
                className={styles.commentAvt}
                name={user && user?.name?.split(" ")[0] + user?.name?.split(' '[1])}
                size="37"
                round={true}
              />
            }

          </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
